import { render, staticRenderFns } from "./VisionModal.vue?vue&type=template&id=10e9dbe2&scoped=true"
import script from "./VisionModal.vue?vue&type=script&lang=js"
export * from "./VisionModal.vue?vue&type=script&lang=js"
import style0 from "./VisionModal.vue?vue&type=style&index=0&id=10e9dbe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e9dbe2",
  null
  
)

export default component.exports